<h2 mat-dialog-title>Confirm contact import</h2>

<mat-dialog-content>
    <!-- <p>
        @if (data.newContact) {
        A <b>new</b> contact will be created
        } @else {
        An existing contact will be updated
        }
    </p>
    <p>
        @if (data.newOrganisation) {
        A <b>new</b> organisation will be created
        } @else {
        An existing organisation will be updated
        }
    </p> -->
    <table class="confirm-table">
        <thead>
            <tr>
                <th>Field</th>
                <th>Uploaded value</th>
                <th>Value</th>
                <th>Status</th>
            </tr>
        </thead>

        <tbody>
            @for (row of rows; track row.label) {
            <tr [class.modified]="row.modified">
                <td>{{ row.label }}</td>
                <td>
                    @if (isArray(row.originalValue)) {
                    @if (row.originalValue.length > 0) {
                    <mat-chip-set>
                        @for (v of row.originalValue; track v) {
                        <mat-chip>{{ v }}</mat-chip>
                        }
                    </mat-chip-set>
                    } @else {
                    —
                    }
                    } @else {
                    {{ row.originalValue || '—' }}
                    }
                </td>
                <td>
                    @if (isArray(row.newValue)) {
                    @if (row.newValue.length > 0) {
                    <mat-chip-set>
                        @for (v of row.newValue; track v) {
                        <mat-chip>{{ v }}</mat-chip>
                        }
                    </mat-chip-set>
                    } @else {
                    —
                    }
                    } @else {
                    {{ row.newValue || '—' }}
                    }
                </td>
                <td>
                    @if (row.added) {
                    <span class="material-symbols-outlined n-modified-data"
                        matTooltip="New {{row.added}} will be created">
                        add_alert
                    </span>
                    }
                    @if (row.modified) {
                    <span class="material-symbols-outlined n-modified-data" matTooltip="Data has been manually updated">
                        edit_notifications
                    </span>
                    }
                    @if (!(row.added || row.modified)) {
                    —
                    }
                </td>
            </tr>
            }
        </tbody>
    </table>

    <p style="padding: 5px 25px; color: var(--nexus-dark-blue)">When updating an existing contact, stakeholder groups and topics of interest are <b>merged</b> with contact's existing ones.</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button matButton mat-dialog-close>Cancel</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button matButton [mat-dialog-close]="true">Confirm</button>
</mat-dialog-actions>